<template>
  <div>
    <div class="content-wrapper">
      <div class="content-header row"></div>
      <div class="content-body">
        <section class="flexbox-container">
          <div
            class="col-md-4 offset-md-4 col-xs-10 offset-xs-1 box-shadow-2 p-0"
          >
            <div class="card border-grey border-lighten-3 m-0">
              <div class="card-header no-border">
                <div class="card-title text-xs-center">
                  <div class="p-0">
                    <img
                      src="/static/app-assets/images/logo/logo_tr.png"
                      alt="CITY GAS SERVICE"
                    />
                  </div>
                </div>
                <h6
                  class="card-subtitle line-on-side text-muted text-xs-center font-small-3 pt-1"
                >
                  <span>Авторизация в личном кабинете</span>
                </h6>
              </div>
              <div class="card-body collapse in">
                <div class="card-block">
                  <form
                    class="form-horizontal form-simple"
                    action="login-work.php"
                    method="post"
                    novalidate
                    @submit.prevent="logIn"
                  >
                    <p v-if="showError" class="text-xs-center text-danger">
                      Неверное сочетание логина и пароля
                    </p>
                    <fieldset
                      class="form-group position-relative has-icon-left mb-0"
                    >
                      <input
                        type="text"
                        class="form-control form-control-lg input-lg"
                        id="user-name"
                        name="user"
                        placeholder="Ваш логин"
                        required
                        v-model="login"
                      />
                      <div class="form-control-position">
                        <i class="icon-head"></i>
                      </div>
                    </fieldset>
                    <fieldset
                      class="form-group position-relative has-icon-left mb-0"
                    >
                      <input
                        type="password"
                        class="form-control form-control-lg input-lg"
                        id="user-password"
                        name="pass"
                        placeholder="Введите пароль"
                        required
                        v-model="password"
                      />
                      <div class="form-control-position">
                        <i class="icon-key3"></i>
                      </div>
                    </fieldset>
                    <fieldset class="form-group row">
                      <div
                        class="col-md-6 col-xs-12 text-xs-center text-md-left"
                      >
                        <fieldset>
                          <input
                            type="checkbox"
                            id="remember-me"
                            class="chk-remember"
                          />
                          <label for="remember-me" style="margin-left: 5px"
                            >Запомнить меня</label
                          >
                        </fieldset>
                      </div>
                      <div
                        class="col-md-6 col-xs-12 text-xs-center text-md-right"
                      >
                        <router-link to="/recover" class="card-link"
                          >Забыли пароль?</router-link
                        >
                      </div>
                    </fieldset>
                    <button
                      type="submit"
                      name="submit"
                      class="btn btn-primary btn-lg btn-block"
                    >
                      <i class="icon-unlock2"></i> Вход
                    </button>
                  </form>
                </div>
              </div>
              <div class="card-footer" v-if="isRegistrationEnabled">
                <h6
                  class="card-subtitle line-on-side text-muted text-xs-center font-small-3 pt-0"
                >
                  <span
                    >Если Вы не зарегистрированы. Только для физических
                    лиц</span
                  >
                </h6>

                <div align="center">
                  <router-link
                    to="/register"
                    class="btn btn-info btn-min-width mr-1 mb-1"
                    >Зарегистрироваться</router-link
                  >
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { AUTH_REQUEST } from "@/store/actions/auth";
export default {
  name: "Login",
  data() {
    return {
      login: null,
      password: null,
      showError: false,
    };
  },
  computed: {
    ...mapGetters(["isRegistrationEnabled"]),
  },
  methods: {
    logIn: function () {
      const { login, password } = this;
      this.$store
        .dispatch(AUTH_REQUEST, { login, password })
        .then(() => {
          this.$router.go();
          this.$router.push("/");
        })
        .catch(() => {
          this.showError = true;
        });
    },
  },
};
</script>